import React from 'react'

import { RIFoptionsMethal } from '../../../data/stamp/RIFdata'
import SelectInput from '../SelectInput'

const RIFSelectMethal = (props) => {
  return <SelectInput options={RIFoptionsMethal} isMulti {...props} />
}

export default RIFSelectMethal
